import Vue from 'vue'
import vuex from 'vuex'
import Router from 'vue-router'

import home from '@/components/home/home'
import Index from '@/components/home/index'
import channellines from '@/components/home/channelline'
import branches from '@/components/home/tmsbranches'
import enterpriselist from '@/components/home/enterpriselist'
import enterprise from '@/components/home/enterprise'
import channel from '@/components/home/channel'
import notice from '@/components/home/notice'
import Login from '@/components/home/login'
import Register from '@/components/home/register'
import etms from '@/components/etms/home'

import CreateDelivery from '@/components/etms/ctms/create_delivery'
import ImportWaybill from '@/components/etms/ctms/import_waybill'
import MyWaybill from '@/components/etms/ctms/my_waybill'
import WaybillPrint from '@/components/etms/ctms/waybill_print'
import MyTemplate from '@/components/etms/ctms/my_template'
import DeliverySetting from '@/components/etms/ctms/deliver_setting'
import MyAddress from '@/components/etms/ctms/my_address'
import WaybillFeeDetails from '@/components/etms/ctms/waybill_fee_details'
import LogisticsBills from '@/components/etms/ctms/logistics_bills'

import CreateWaybill from '@/components/etms/tms/create_waybill'
import TmsImportWaybill from '@/components/etms/tms/import_waybill'
import WaybillManage from '@/components/etms/tms/waybill_manage'
import BranchScan from '@/components/etms/tms/branch_scan'
import InboundProcessing from '@/components/etms/tms/inbound_processing'
import OutboundProcessing from '@/components/etms/tms/outbound_processing'
import TmsWaybillPrint from '@/components/etms/tms/waybill_print'
import WorkWaybillProcessing from '@/components/etms/tms/work_waybill_processing'
import ChannelManage from '@/components/etms/tms/channel_manage'
import LineManage from '@/components/etms/tms/line_manage'
import BillingCategory from '@/components/etms/tms/billing_category'
import OddNumManage from '@/components/etms/tms/oddnum_manage'
import ChannelDocking from '@/components/etms/tms/channel_docking'
import EcDocking from '@/components/etms/tms/ec_docking'
import ChannelPriceSetting from '@/components/etms/tms/channel_price_setting'
import SupplierManage from '@/components/etms/tms/supplier_manage'
import SupplierDiscountSetting from '@/components/etms/tms/supplier_discount_setting'
import CustomerManage from '@/components/etms/tms/customer_manage'
import CustomerDiscountSetting from '@/components/etms/tms/customer_discount_setting'
import CustomerWaybillAccounting from '@/components/etms/tms/customer_waybill_accounting'
import CustomerOutBill from '@/components/etms/tms/customer_out_bill'
import CustomerBillManage from '@/components/etms/tms/customer_bill_manage'
import SupplierWaybillAccounting from '@/components/etms/tms/supplier_waybill_accounting'
import SupplierOutBill from '@/components/etms/tms/supplier_out_bill'
import SupplierBillManage from '@/components/etms/tms/supplier_bill_manage'
import CustomerFeeImport from '@/components/etms/tms/customer_fees_import'
import SupplierFeeImport from '@/components/etms/tms/supplier_fees_import'
import StoreSetting from '@/components/etms/tms/store_setting'

import EntSetting from '@/components/etms/ems/ent_setting'
import BranchesManage from '@/components/etms/ems/branches_manage'
import DepManage from '@/components/etms/ems/dep_manage'
import PositionManage from '@/components/etms/ems/position_manage'
import AccountManage from '@/components/etms/ems/account_manage'
import PersonalInfo from '@/components/etms/ems/personal_info'
import SafeInfo from '@/components/etms/ems/safe_info'

import test from '@/components/etms/test'

Vue.use(vuex)
Vue.use(Router)

var ctms = '/etms/ctms/'
var tms = '/etms/tms/'
var ems = '/etms/ems/'
var sitename = '逸天环球'

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      meta: {
        titie: sitename
      },
      children: [
        {
          path: '/',
          name: 'index',
          component: Index,
          meta: {
            title: '首页-' + sitename
          }
        },
        {
          path: '/branches',
          name: 'branches',
          component: branches,
          meta: {
            title: '网点查询-' + sitename
          }
        },
        {
          path: '/channellines',
          name: 'channellines',
          component: channellines,
          meta: {
            title: '线路发货-' + sitename
          }
        },
        {
          path: '/enterpriselist',
          name: 'enterpriselist',
          component: enterpriselist,
          meta: {
            title: '企业黄页-' + sitename
          }
        },
        {
          path: '/enterprise',
          name: 'enterprise',
          component: enterprise,
          meta: {
            title: '企业信息-' + sitename
          }
        },
        {
          path: '/channel',
          name: 'channel',
          component: channel,
          meta: {
            title: '渠道信息-' + sitename
          }
        },
        {
          path: '/notice',
          name: 'notice',
          component: notice,
          meta: {
            title: '资讯公告-' + sitename
          }
        },
        {
          path: '/login',
          name: 'login',
          component: Login,
          meta: {
            title: '登录-' + sitename
          }
        },
        {
          path: '/register',
          name: 'register',
          component: Register,
          meta: {
            title: '首页-' + sitename
          }
        }
      ]
    },
    {
      path: '/etms',
      name: 'etms',
      component: etms,
      meta: {
        title: sitename
      },
      children: [
        {
          path: ctms + 'create_delivery',
          name: 'create_delivery',
          component: CreateDelivery,
          meta: {
            title: '我要发货-' + sitename
          }
        },
        {
          path: ctms + 'import_waybill',
          name: 'import_waybill',
          component: ImportWaybill,
          meta: {
            title: '导入运单-' + sitename
          }
        },
        {
          path: ctms + 'my_waybill',
          name: 'my_waybill',
          component: MyWaybill,
          meta: {
            title: '我的运单-' + sitename
          }
        },
        {
          path: ctms + 'waybill_print',
          name: 'waybill_print',
          component: WaybillPrint,
          meta: {
            title: '面单打印-' + sitename
          }
        },
        {
          path: ctms + 'my_template',
          name: 'my_template',
          component: MyTemplate,
          meta: {
            title: '我的模版-' + sitename
          }
        },
        {
          path: ctms + 'deliver_setting',
          name: 'deliver_setting',
          component: DeliverySetting,
          meta: {
            title: '发货设置-' + sitename
          }
        },
        {
          path: ctms + 'my_address',
          name: 'my_address',
          component: MyAddress,
          meta: {
            title: '我的地址-' + sitename
          }
        },
        {
          path: ctms + 'waybill_fee_details',
          name: 'waybill_fee_details',
          component: WaybillFeeDetails,
          meta: {
            title: '运费明细-' + sitename
          }
        },
        {
          path: ctms + 'logistics_bills',
          name: 'logistics_bills',
          component: LogisticsBills,
          meta: {
            title: '物流账单-' + sitename
          }
        },
        {
          path: tms + 'create_waybill',
          name: 'create_waybill',
          component: CreateWaybill,
          meta: {
            title: '创建运单-' + sitename
          }
        },
        {
          path: tms + 'import_waybill',
          name: 'tms_import_waybill',
          component: TmsImportWaybill,
          meta: {
            title: '导入运单-' + sitename
          }
        },
        {
          path: tms + 'waybill_manage',
          name: 'waybill_manage',
          component: WaybillManage,
          meta: {
            title: '运单管理-' + sitename
          }
        },
        {
          path: tms + 'branch_scan',
          name: 'branch_scan',
          component: BranchScan,
          meta: {
            title: '网点扫件-' + sitename
          }
        },
        {
          path: tms + 'inbound_processing',
          name: 'inbound_processing',
          component: InboundProcessing,
          meta: {
            title: '入库处理-' + sitename
          }
        },
        {
          path: tms + 'outbound_processing',
          name: 'outbound_processing',
          component: OutboundProcessing,
          meta: {
            title: '出库处理-' + sitename
          }
        },
        {
          path: tms + 'waybill_print',
          name: 'tms_waybill_print',
          component: TmsWaybillPrint,
          meta: {
            title: '面单打印-' + sitename
          }
        },
        {
          path: tms + 'work_waybill_processing',
          name: 'work_waybill_processing',
          component: WorkWaybillProcessing,
          meta: {
            title: '工单处理-' + sitename
          }
        },
        {
          path: tms + 'channel_manage',
          name: 'channel_manage',
          component: ChannelManage,
          meta: {
            title: '渠道管理-' + sitename
          }
        },
        {
          path: tms + 'line_manage',
          name: 'line_manage',
          component: LineManage,
          meta: {
            title: '线路管理-' + sitename
          }
        },
        {
          path: tms + 'billing_category',
          name: 'billing_category',
          component: BillingCategory,
          meta: {
            title: '计费分类-' + sitename
          }
        },
        {
          path: tms + 'oddnum_manage',
          name: 'oddnum_manage',
          component: OddNumManage,
          meta: {
            title: '号段管理-' + sitename
          }
        },
        {
          path: tms + 'channel_docking',
          name: 'channel_docking',
          component: ChannelDocking,
          meta: {
            title: '抓单对接-' + sitename
          }
        },
        {
          path: tms + 'ec_docking',
          name: 'ec_docking',
          component: EcDocking,
          meta: {
            title: '电商对接-' + sitename
          }
        },
        {
          path: tms + 'channel_price_setting',
          name: 'channel_price_setting',
          component: ChannelPriceSetting,
          meta: {
            title: '价格设置-' + sitename
          }
        },
        {
          path: tms + 'supplier_manage',
          name: 'supplier_manage',
          component: SupplierManage,
          meta: {
            title: '供应商管理-' + sitename
          }
        },
        {
          path: tms + 'supplier_discount_setting',
          name: 'supplier_discount_setting',
          component: SupplierDiscountSetting,
          meta: {
            title: '供应商折扣设置-' + sitename
          }
        },
        {
          path: tms + 'customer_manage',
          name: 'customer_manage',
          component: CustomerManage,
          meta: {
            title: '客户管理-' + sitename
          }
        },
        {
          path: tms + 'customer_discount_setting',
          name: 'customer_discount_setting',
          component: CustomerDiscountSetting,
          meta: {
            title: '客户折扣设置-' + sitename
          }
        },
        {
          path: tms + 'customer_waybill_accounting',
          name: 'customer_waybill_accounting',
          component: CustomerWaybillAccounting,
          meta: {
            title: '客户运单核算-' + sitename
          }
        },
        {
          path: tms + 'customer_out_bill',
          name: 'customer_out_bill',
          component: CustomerOutBill,
          meta: {
            title: '客户出账-' + sitename
          }
        },
        {
          path: tms + 'customer_bill_manage',
          name: 'customer_bill_manage',
          component: CustomerBillManage,
          meta: {
            title: '客户账单管理-' + sitename
          }
        },
        {
          path: tms + 'supplier_waybill_accounting',
          name: 'supplier_waybill_accounting',
          component: SupplierWaybillAccounting,
          meta: {
            title: '供应运单核算-' + sitename
          }
        },
        {
          path: tms + 'supplier_out_bill',
          name: 'supplier_out_bill',
          component: SupplierOutBill,
          meta: {
            title: '供应商出账-' + sitename
          }
        },
        {
          path: tms + 'supplier_bill_manage',
          name: 'supplier_bill_manage',
          component: SupplierBillManage,
          meta: {
            title: '供应商账单管理-' + sitename
          }
        },
        {
          path: tms + 'customer_fees_import',
          name: 'customer_fees_import',
          component: CustomerFeeImport,
          meta: {
            title: '客户费用导入-' + sitename
          }
        },
        {
          path: tms + 'supplier_fees_import',
          name: 'supplier_fees_import',
          component: SupplierFeeImport,
          meta: {
            title: '供应商费用导入-' + sitename
          }
        },
        {
          path: tms + 'store_setting',
          name: 'store_setting',
          component: StoreSetting,
          meta: {
            title: '店铺设置-' + sitename
          }
        },
        {
          path: ems + 'ent_setting',
          name: 'ent_setting',
          component: EntSetting,
          meta: {
            title: '企业设置-' + sitename
          }
        },
        {
          path: ems + 'branches_manage',
          name: 'branches_manage',
          component: BranchesManage,
          meta: {
            title: '网点管理-' + sitename
          }
        },
        {
          path: ems + 'dep_manage',
          name: 'dep_manage',
          component: DepManage,
          meta: {
            title: '部门管理-' + sitename
          }
        },
        {
          path: ems + 'position_manage',
          name: 'position_manage',
          component: PositionManage,
          meta: {
            title: '职位管理-' + sitename
          }
        },
        {
          path: ems + 'account_manage',
          name: 'account_manage',
          component: AccountManage,
          meta: {
            title: '账号管理-' + sitename
          }
        },
        {
          path: ems + 'personal_info',
          name: 'personal_info',
          component: PersonalInfo,
          meta: {
            title: '个人信息-' + sitename
          }
        },
        {
          path: ems + 'safe_info',
          name: 'safe_info',
          component: SafeInfo,
          meta: {
            title: '安全信息-' + sitename
          }
        }
      ]
    },
    {
      path: '/test/',
      name: 'test',
      component: test,
      meta: {
        title: '测试-' + sitename
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js